import React, { useState } from 'react';
import { Form, Input } from 'antd';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { FormItem } from 'component/form_component/style';

const ViewApi = ({ recordData }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyClick = () => {
    const combinedText = `API Key: ${recordData?.apiKey}, API Secret: ${recordData?.apiSecret}`;
    navigator.clipboard.writeText(combinedText).then(() => setCopied(true));
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div className='af-modal-wrap af-modal-wrap-apiKeys'>
      <h2 style={{ marginBottom: 24 }} className='af-form-header af-view_apikeys-form-header'>
        API Keys
      </h2>
      <Form
        className='af-form af-view_apikeys-form'
        name='view_apikeys'
        size='large'
        layout='vertical'
        initialValues={{ name: recordData?.name, apiKey: recordData?.apiKey, apiSecret: recordData?.apiSecret }}
      >
        <FormItem
          className='formItemEvenLine af-form-item af-view_apikeys-form-item af-view_apikeys-form-item-name'
          name='name'
          label='Name'
        >
          <Input
            disabled={true}
            onContextMenu={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
            onDragStart={(e) => e.preventDefault()}
            className='af-form-input af-view_apikeys-form-input af-view_apikeys-form-input_name no-copy-input'
          />
        </FormItem>
        <FormItem
          className='formItemEvenLine af-form-item af-view_apikeys-form-item af-view_apikeys-form-item-apikey1'
          name='apiKey'
          label='API Key:'
        >
          <Input
            disabled={true}
            onContextMenu={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
            onDragStart={(e) => e.preventDefault()}
            className='af-form-input af-view_apikeys-form-input af-view_apikeys-form-input_apikey1 no-copy-input'
          />
        </FormItem>
        <FormItem
          name='apiSecret'
          className='formItemEvenLine af-form-item af-view_apikeys-form-item af-view_apikeys-form-item-apikey2'
          label='API Secret:'
        >
          <Input
            disabled={true}
            onContextMenu={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
            onDragStart={(e) => e.preventDefault()}
            className='af-form-input af-view_apikeys-form-input af-view_apikeys-form-input_apikey2 no-copy-input'
          />
        </FormItem>
        <FormItem
          className='af-form-button-submit-wrapper af-view_apikeys-form-button-submit-wrapper'
          style={{ textAlign: 'end' }}
        >
          <StyledButton
            type='primary'
            className='af-form-button af-view_apikeys-form-button af-view_apikeys-form-copy_api'
            onClick={handleCopyClick}
          >
            {copied ? 'Copied' : 'Copy Keys'}
          </StyledButton>
        </FormItem>
      </Form>
    </div>
  );
};

export default ViewApi;
